import { Component, inject } from '@angular/core';
import { ActivityService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityCreateDto,
  ActivityDto,
  ActivityExcelDownloadDto,
  ActivityUpdateDto,
} from '../proxy/controlling/dtos/activity';
import { ACTIVITY_CONFIG, ACTIVITY_FIELDS } from './activity.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activity',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, ActivityService, ConfirmationService],
  templateUrl: './activity.html',
  styleUrl: './activity.scss',
})
export class Activity extends BaseHierarchicalCrudComponent<
  ActivityDto,
  ActivityCreateDto,
  ActivityUpdateDto,
  ActivityExcelDownloadDto
> {
  service = inject(ActivityService);
  config = ACTIVITY_CONFIG;
  fields = ACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityDto): ActivityUpdateDto {
    return {
      name: data.name,
      isDirect: data.isDirect,
      shouldCheckDocumentation: data.shouldCheckDocumentation,
      hasSpecificParametrization: data.hasSpecificParametrization,
      canAcceptConsumable: data.canAcceptConsumable,
      forRetroCompatibility: data.forRetroCompatibility,
      wbsId: data.wbsId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Activity';
  }
}
